module.exports = __webpack_public_path__ + "static/major-works-main-hub-4-561213ebe8c5257f66defa7c612100e4.png";